import $ from 'jquery';
import Raven from 'raven-js';
import _ from 'lodash';
import Tether from 'tether';
window._ = _;
window.Raven = Raven;
window.jQuery = $; window.$ = $;
window.Tether = Tether
require('bootstrap');
